import {CachingCollection} from "../../../collections/_BaseCollection";

export class BaseWeatherCollection<TModel extends Backbone.Model> extends CachingCollection<TModel> {
    appUrlRoot = 'weather';
}


// WEBPACK FOOTER //
// ./srv/public/js/apps/weather/collections/_BaseLocationCollection.ts